import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { http, errorMessage } from "../../lib/api";
import { useAuth } from "./AuthContext";

export const AdminLogin = () => {
  const { setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await http.post("/auth/login", { email, password });
      setUser(data);
    } catch (err) {
      setError(errorMessage(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="grid min-h-[80vh] place-items-center px-5 pt-[100px] pb-16">
      <form onSubmit={submit} className="w-full max-w-md rounded-[2rem] border border-slate-200 bg-white p-8 md:p-10 shadow-[0_30px_60px_-40px_rgba(27,47,91,0.5)]" data-testid="admin-login-form">
        <span className="grid h-12 w-12 place-items-center rounded-2xl bg-[color:var(--navy)] text-white"><Lock size={20} /></span>
        <h1 className="mt-6 text-2xl font-bold text-[color:var(--navy)]">Team-Bereich</h1>
        <p className="mt-2 text-sm text-slate-600">Nur für berechtigte Mitarbeitende von PACTORA.</p>
        <label htmlFor="admin-email" className="mt-8 block text-sm font-semibold text-[color:var(--navy)]">E-Mail</label>
        <input id="admin-email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} className="field-input mt-2" data-testid="admin-login-email" />
        <label htmlFor="admin-password" className="mt-5 block text-sm font-semibold text-[color:var(--navy)]">Passwort</label>
        <input id="admin-password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className="field-input mt-2" data-testid="admin-login-password" />
        {error && <p role="alert" className="mt-4 text-sm text-[#B91C1C]" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} className="mt-8 inline-flex w-full items-center justify-center gap-2 rounded-full bg-[color:var(--navy)] py-4 font-semibold text-white hover:bg-[color:var(--navy-deep)] disabled:opacity-60" data-testid="admin-login-submit">
          {busy && <Loader2 size={18} className="animate-spin" />} Anmelden
        </button>
      </form>
    </div>
  );
};
